<div class="flex max-h-[90vh] flex-col overflow-hidden">
  <div class="flex shrink-0 flex-col gap-5 p-6 pb-0">
    <div
      class="flex size-12 justify-center rounded-full bg-blue-light p-3 align-middle"
    >
      <mat-icon class="material-icons-outlined hvs-icon-xxl text-blue">
        link
      </mat-icon>
    </div>
    <p class="text-xl font-semibold text-blue-dark">
      {{ 'portal.hrisIntegration.filtersDialog.title' | transloco }}
    </p>
    <p class="text-sm font-medium text-blue-dark">
      {{ 'portal.hrisIntegration.filtersDialog.subtitle' | transloco }}
    </p>
  </div>
  @if (hrisIntegrationDataService.hrisIntegration) {
    <div
      class="m-6 min-h-0 flex-1 overflow-y-auto overflow-x-hidden rounded-lg border border-grey-lightGrey"
    >
      <div class="flex items-center justify-between p-4 transition-colors">
        <div class="flex items-center gap-3">
          <span class="font-medium text-gray-900">
            {{
              'portal.hrisIntegration.filtersDialog.types.groups' | transloco
            }}
            <span class="font-normal text-grey"
              >({{ getSelectedCount(filters()) }})</span
            >
          </span>
        </div>
        <app-input-field
          [control]="searchControl"
          [placeholder]="'general.search' | transloco"
          [icon]="'search'"
          [bottomMargin]="false"
        />
      </div>
      @if (filtersToDisplay().length > 0) {
        <div class="flex flex-wrap gap-3 p-4">
          @for (filter of filtersToDisplay(); track filter.id) {
            <mat-checkbox
              [checked]="filter.selected"
              (keydown.enter)="toggleFilter(filter.id)"
              (change)="toggleFilter(filter.id)"
            >
              {{ filter.name }}
            </mat-checkbox>
          }
        </div>
      } @else {
        <div class="flex justify-center p-2 italic text-grey">
          {{
            'portal.hrisIntegration.filtersDialog.noFiltersAvailable'
              | transloco
          }}
        </div>
      }
    </div>
  }
  <div class="grid shrink-0 grid-cols-2 gap-3 border-t border-gray-200 p-6">
    <app-secondary-button
      [text]="'portal.hrisIntegration.filtersDialog.cancelButton' | transloco"
      (buttonClicked)="onCancelButtonClicked()"
    ></app-secondary-button>
    <app-primary-button
      [text]="'portal.hrisIntegration.filtersDialog.saveButton' | transloco"
      (buttonClicked)="onSaveButtonClicked()"
    ></app-primary-button>
  </div>
</div>
